import React from 'react';
import {
  Tag, SelectNative, SelectNativeOption, useMediaQuery, mediaQueries,
} from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { useGetInspirationalArticlesHook } from '../../../hooks/useGetInspirationalArticlesHook';

export const InspirationFilterButtons = ({
  activeTag, setActiveTag, isInViewport, triggerOnClickAnalytics,
}) => {
  const { formatMessage } = useIntl();
  const { data: getInspiredArticles, isLoading } = useGetInspirationalArticlesHook(isInViewport);
  const isSmVP = useMediaQuery(mediaQueries.MD_DOWN);
  const categories = [
    { category: 'Articles', categoryName: `${formatMessage({ id: 'getInspired.articles' })}` },
    { category: 'Guides', categoryName: `${formatMessage({ id: 'getInspired.guides' })}` },
    { category: 'Itineraries', categoryName: `${formatMessage({ id: 'getInspired.itineraries' })}` },
  ];

  if (isLoading || !isInViewport || (!isLoading && !getInspiredArticles)) {
    return (
      <div className="row pad-1-b">
        <div className="col-sm-12 flex">
          <Skeleton className="margin-1-r" inline={true} height="2.5rem" width="7rem" borderRadius="2rem" />
        </div>
      </div>
    );
  }

  const filterTags = categories
    .filter((tag) => Object.keys(getInspiredArticles).includes(tag.category));

  if (isSmVP) {
    return (
      <SelectNative
        id="filter-by-select"
        label={formatMessage({ id: 'getInspired.selectCategory' })}
        aria-label={formatMessage({ id: 'getInspired.selectCategory' })}
        status="default"
        value={activeTag}
        onChange={(e) => {
          const value = categories.find((tag) => tag.categoryName === e.target.value);
          triggerOnClickAnalytics(`${value.category.toLowerCase()}-filter`);
          setActiveTag(value.category);
        }}
        className="pad-2-b"
      >
        {
              filterTags.map((tag) => (
                <SelectNativeOption
                  key={tag.category}
                  value={tag.categoryName}
                  aria-label={tag.categoryName}
                >
                  {tag.categoryName}
                </SelectNativeOption>
              ))
          }
      </SelectNative>
    );
  }

  return (
    <div className="row pad-1-b">
      <div className="col-sm-12">
        {
            filterTags.map((tag) => (
              <Tag
                aria-label={`${formatMessage({ id: 'getInspired.filterBy' })} ${tag.category}`}
                id={`filter-${tag.category}-tag`}
                key={tag.category}
                className="pad-1-r pad-1-b"
                reactlytics={{
                  element: `hp-get-inspired-${activeTag?.toLowerCase()}`,
                  detail: `${tag.category.toLowerCase()}-filter`,
                }}
                aria-pressed={activeTag === tag.category}
                onClick={() => setActiveTag(tag.category)}
              >
                {tag.categoryName}
              </Tag>
            ))
          }
      </div>
    </div>
  );
};

InspirationFilterButtons.propTypes = {
  activeTag: PropTypes.string,
  setActiveTag: PropTypes.func,
  isInViewport: PropTypes.bool.isRequired,
  triggerOnClickAnalytics: PropTypes.func,
};
